import React, { FC } from 'react';
import Text from '../Text';
import Icons from 'components/icons';
import Link from 'next/link';

type RoomButtonProps = {
  title: string;
  url: string;
};

const RoomButton: FC<RoomButtonProps> = (props) => {
  const { url, title } = props;

  return (
    <Link href={url} className="group no-underline hover:no-underline">
      <div className="bg-grey-50 group-hover:bg-grey-800 transition-all duration-500 p-10 rounded-2xl grid grid-cols-[1fr_auto] items-center">
        <Text
          bold
          elementType="div"
          size="large"
          className="group-hover:text-white"
        >
          {title}
        </Text>
        <div className="aspect-square bg-blue group-hover:bg-grey-800 h-12 text-white rounded-full inline-flex items-center justify-center">
          <Icons.Arrow className="!h-6" />
        </div>
      </div>
    </Link>
  );
};

export default RoomButton;
